<template>
  <div class="webcams-container">
    <h1 class="title">
      {{ $t('Cams') }}
    </h1>
    <div class="scroll-btn scroll-up" @click.prevent="scrollUp()" :class="{ 'hide-scroll' : hideScrollUp }">
      <img src="@/assets/icons/up-arrow-white.svg" alt="Scroll Up">
    </div>
    <div class="webcams-animate-container">
      <div class="webcams" :style="translateStyle">
        <Webcam v-for="webcam in webcams" :webcam="webcam" :webcamTitleField="webcamTitleField" :key="webcam.Title" v-on:showWebcamModal="showWebcamModal"></Webcam>
      </div>
    </div>
    <div class="scroll-btn scroll-down" @click.prevent="scrollDown()" :class="{ 'hide-scroll' : hideScrollDown }">
      <img src="@/assets/icons/down-arrow-white.svg" alt="Scroll Down">
    </div>
    <WebcamModal :webcam="currentWebcam" :webcamTitleField="webcamTitleField" v-if="showModal" v-on:closeModal="closeModal"></WebcamModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Webcam from './Webcams/Webcam.vue';
import WebcamModal from './Webcams/WebcamModal.vue';

export default {
  name: 'Webcams',
  data() {
    return {
      container: null,
      camSlide: null,
      currentWebcam: null,
      showModal: false,
      translateY: 0,
    };
  },
  components: {
    Webcam,
    WebcamModal,
  },
  computed: {
    ...mapGetters(['webcams', 'webcamTitleField']),
    translateStyle() {
      return `transform: translateY(${this.translateY}px)`;
    },
    hideScrollDown() {
      if (this.webcams && this.webcams.size < 4) { return true; }
      if (!this.camSlide) { return false; }
      if (this.camSlide.scrollHeight == 0) { return false; }

      return this.container
        && Math.abs(this.translateY) + 100 >= this.camSlide.scrollHeight / 1.5;
    },
    hideScrollUp() {
      return this.translateY == 0 || this.webcams.length < 4;
    },
  },
  methods: {
    showWebcamModal(vueEvent) {
      this.currentWebcam = vueEvent.webcam;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    scrollUp() {
      this.translateY = this.translateY + (this.camSlide.scrollHeight / 3);
      if (this.translateY > 0) { this.translateY = 0; }
    },
    scrollDown() {
      this.translateY = this.translateY - (this.camSlide.scrollHeight / 3);

      if (Math.abs(this.translateY) > this.camSlide.scrollHeight / 1.5) {
        this.translateY = 0;
      }
    },
    reflow() {
      // TODO: once this works, we can call reflow on a window resize event
      this.translateY = 0;
      this.container = document.querySelector('.webcams-container');
      this.camSlide = document.querySelector('.webcams');
    },
  },
  mounted() {
    this.reflow();
  },
};
</script>

<style lang="scss" scoped>
.webcams-container {
  background-color: $white;
  padding: 20px;
  overflow: hidden;
  position: relative;
  width: 100%;
  .scroll-btn {
    background-color: $alert-bar-background;
    cursor: pointer;
    display: none;
    height: auto;
    position: absolute;
    left: 37.5%;
    width: 25%;
    z-index: 5;
    @media (min-width: $tablet-landscape) {
      display: block;
    }
    img {
      fill: $white;
      display: block;
      margin: 5px auto;
      width: 45%;
    }
    &.scroll-up {
      top: 72px;
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
      &.hide-scroll {
        cursor: none;
        pointer-events: none;
        opacity: 0;
      }
    }
    &.scroll-down {
      bottom: 0;
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
      &.hide-scroll {
        cursor: none;
        pointer-events: none;
        opacity: 0;
      }
    }
  }
  .webcams-animate-container {
    overflow: hidden;
    max-height: 100%;
    .webcams {
      font-family: $base-font-regular;
      font-size: 16px;
      transition: all ease-in-out 0.5s;
      @media (max-width: $tablet-landscape) {
        transform: translateY(0) !important
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Cams": "CAMÉRAS"
}
</i18n>
